<div class="message bg-lite-1" [ngClass]="{'no-padding': is_no_padding}">
  <div class="icon">
    <app-icon *ngIf="app_icon" [name]="app_icon"></app-icon>
    <ion-icon *ngIf="ion_icon" [name]="ion_icon"></ion-icon>
  </div>
  <div *ngIf="text"  class="text">
    {{text | translate}}
  </div>
  <ion-button *ngIf="btn_text" [ngClass]="btn_class" (click)="btn_callback.emit()">
    {{btn_text | translate}}
  </ion-button>
  <ion-button *ngIf="btn_text_2" [ngClass]="btn_class_2" (click)="btn_callback_2.emit()">
    {{btn_text_2 | translate}}
  </ion-button>
</div>